import React, { useRef, useState } from "react";
import { Modal, Button, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";

import { actionNewPassword } from "../../redux/actions/login/login";
import { notify } from "../ui";

function Home({ show, setShow, correo, code }) {
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const inputRef2 = useRef(null);

  const close = () => {
    if (loading) return;
    setShow(false);
  };

  const validate = () => {
    const next = {};
    if (!newPassword) next.newPassword = "La contraseña es obligatoria.";
    else if (newPassword.length < 6) next.newPassword = "Usa al menos 6 caracteres.";
    else if (newPassword.length > 15) next.newPassword = "La contraseña no puede exceder 15 caracteres.";

    if (!confirmPassword) next.confirmPassword = "Confirma la contraseña.";
    else if (confirmPassword.length < 6) next.confirmPassword = "Usa al menos 6 caracteres.";
    else if (confirmPassword.length > 15) next.confirmPassword = "La contraseña no puede exceder 15 caracteres.";

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!validate()) return;

    if (newPassword !== confirmPassword) {
      notify.error("Las contraseñas no coinciden", "Verifica que ambas contraseñas sean iguales.");
      return;
    }

    if (!correo || !code) {
      notify.error("Información incompleta", "Falta el correo o el código de verificación.");
      return;
    }

    setLoading(true);

    dispatch(
      actionNewPassword(
        { email: correo, code, password: newPassword },
        () => {
          setLoading(false);
          setShow(false);
          notify.success("Contraseña actualizada", "Tu contraseña fue actualizada correctamente.");
          setNewPassword("");
          setConfirmPassword("");
        },
        (err) => {
          setLoading(false);
          notify.error(
            "No se pudo actualizar",
            typeof err === "string" ? err : "Ocurrió un error al actualizar la contraseña."
          );
        }
      )
    );
  };

  return (
    <Modal
      open={show}
      onCancel={close}
      centered
      maskClosable={!loading}
      closable={!loading}
      title={
        <div className="d-flex align-items-start gap-3">
          <div
            className="rounded-3 bg-primary-subtle d-flex align-items-center justify-content-center"
            style={{ width: 40, height: 40, flexShrink: 0 }}
          >
            <i className="bi bi-shield-lock fs-5" />
          </div>
          <div>
            <div className="mb-1">Crear nueva contraseña</div>
            <p className="text-secondary mb-1" style={{ fontWeight: 400 }}>Define una nueva contraseña para tu cuenta.</p>
            <small className="text-secondary">
              Correo: <strong>{correo || "-"}</strong>
            </small>
          </div>
        </div>
      }
      footer={[
        <Button key="cancel" onClick={close} disabled={loading}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={submit}>
          Guardar
        </Button>,
      ]}
    >
      <form onSubmit={submit}>
        <div className="mb-3">
          <label className="d-block mb-1">Nueva contraseña</label>
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Nueva contraseña"
            maxLength={15}
            autoFocus
            disabled={loading}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") inputRef2.current?.focus();
            }}
            status={errors.newPassword ? "error" : ""}
          />
          {errors.newPassword && <div className="text-danger small mt-1">{errors.newPassword}</div>}
        </div>

        <div className="mb-2">
          <label className="d-block mb-1">Confirmar contraseña</label>
          <Input.Password
            ref={inputRef2}
            prefix={<LockOutlined />}
            placeholder="Repite la contraseña"
            maxLength={15}
            disabled={loading}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            status={errors.confirmPassword ? "error" : ""}
          />
          {errors.confirmPassword && <div className="text-danger small mt-1">{errors.confirmPassword}</div>}
        </div>

        <small className="text-secondary">
          Recomendación: usa una contraseña única. Evita reutilizar contraseñas anteriores.
        </small>
      </form>
    </Modal>
  );
}

export default Home;
